/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IDataAttributeRenderer } from '../interfaces';
import { IDictionary } from '../interfaces/IDictionary';

/**
 * Commerce Insights attribute renderer that generates a 'data-m' telemetry attribute
 */
export const commerceInsightsAttributeRenderer: IDataAttributeRenderer = (
    telemetryId: string,
    additionalTelemetryData?: object
): IDictionary<string> => {
    let properties: string = '';

    if (additionalTelemetryData) {
        for (const prop of Object.entries(additionalTelemetryData)) {
            properties += `,"${prop[0]}":"${prop[1]}"`;
        }
    }

    return {
        'data-bi-id': `${telemetryId}`,
        'data-m': `{"tid":"${telemetryId}"${properties}}`
    };
};
